import React from "react";
import { GOOGLE_REVIEWS } from "../data/content";

const formattedRating = () => {
  // Show "5.0" as "5.0" but allow integers like "5" if rating is whole.
  return Number.isInteger(GOOGLE_REVIEWS.rating)
    ? GOOGLE_REVIEWS.rating.toFixed(1)
    : GOOGLE_REVIEWS.rating;
};

// Inline pill-style badge for hero / trust strip
export const GoogleReviewBadge = ({ variant = "light" }) => {
  const isDark = variant === "dark";
  return (
    <a
      href={GOOGLE_REVIEWS.url}
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex items-center gap-2.5 rounded-full px-4 py-2 text-sm transition-colors ${
        isDark
          ? "bg-white/10 hover:bg-white/15 text-white border border-white/15"
          : "bg-white hover:bg-[#F9FAFB] text-[#0A2540] border border-[#E5E7EB]"
      }`}
      data-testid="google-reviews-badge"
    >
      <GoogleG />
      {GOOGLE_REVIEWS.ratingConfirmed ? (
        <>
          <span className="flex items-center gap-1 font-semibold tabular-nums">
            {formattedRating()}
            <span className="text-[#F59E0B]">★</span>
          </span>
          <span className={`${isDark ? "text-white/70" : "text-[#6B7280]"}`}>
            {GOOGLE_REVIEWS.showCount ? `from ${GOOGLE_REVIEWS.count} Google reviews` : "rating on Google"}
          </span>
        </>
      ) : (
        <span className="font-medium">Read our Google reviews</span>
      )}
    </a>
  );
};

// Larger card-style badge for section headers
export const GoogleReviewCard = () => (
  <a
    href={GOOGLE_REVIEWS.url}
    target="_blank"
    rel="noopener noreferrer"
    className="inline-flex items-center gap-4 bg-white border border-[#E5E7EB] rounded-2xl px-6 py-4 hover:border-[#0066FF] hover:shadow-sm transition-all"
    data-testid="google-reviews-card"
  >
    <GoogleG size={28} />
    {GOOGLE_REVIEWS.ratingConfirmed ? (
      <div className="text-left">
        <div className="flex items-center gap-2">
          <div className="font-display font-semibold text-2xl text-[#0A2540] tabular-nums">{formattedRating()}</div>
          <div className="flex text-[#F59E0B] text-base">
            {Array.from({ length: 5 }).map((_, i) => (<span key={i}>★</span>))}
          </div>
        </div>
        <div className="text-xs text-[#6B7280] mt-0.5">
          {GOOGLE_REVIEWS.showCount ? `from ${GOOGLE_REVIEWS.count} verified Google reviews` : `Rated ${formattedRating()} on Google`}
        </div>
      </div>
    ) : (
      <div className="text-left">
        <div className="font-display font-semibold text-lg text-[#0A2540]">Reviews on Google</div>
        <div className="text-xs text-[#6B7280] mt-0.5">See what our clients say ↗</div>
      </div>
    )}
  </a>
);

export const GoogleG = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
  </svg>
);
